<cipo-dialog-header title="a11y.preferences.title" fullScreen="never" />
<mat-dialog-content class="cipo--min-width--350">
    <h4 class="cipo-text--bold-lg p-y-sm" id="a11y-section-text">
        {{ "a11y.preferences.sections.text" | translate }}
    </h4>

    <!-- Text size -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">format_size</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-font-label">
                    {{ "a11y.preferences.textSize.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.textSize.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().fontScale"
            (change)="setFontScale($event.value)"
            aria-labelledby="a11y-pref-font-label"
            data-testid="a11y-pref-font-scale">
            <mat-button-toggle value="normal">{{ "a11y.preferences.textSize.normal" | translate }}</mat-button-toggle>
            <mat-button-toggle value="lg">{{ "a11y.preferences.textSize.lg" | translate }}</mat-button-toggle>
            <mat-button-toggle value="xl">{{ "a11y.preferences.textSize.xl" | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <!-- Dyslexia-friendly font -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">font_download</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-dyslexia-font-label">
                    {{ "a11y.preferences.dyslexiaFont.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.dyslexiaFont.hint" | translate }}</span>
            </div>
        </div>
        <mat-slide-toggle
            [checked]="userStore.a11y().dyslexiaFont"
            (change)="setDyslexiaFont($event)"
            aria-labelledby="a11y-pref-dyslexia-font-label"
            data-testid="a11y-pref-dyslexia-font"></mat-slide-toggle>
    </div>

    <mat-divider />

    <!-- Text spacing (horizontal: letter + word) -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">swap_horiz</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-text-spacing-label">
                    {{ "a11y.preferences.textSpacing.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.textSpacing.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().textSpacing"
            (change)="setTextSpacing($event.value)"
            aria-labelledby="a11y-pref-text-spacing-label"
            data-testid="a11y-pref-text-spacing">
            <mat-button-toggle value="normal" data-testid="a11y-pref-text-spacing-normal">
                {{ "a11y.preferences.textSpacing.normal" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="comfortable" data-testid="a11y-pref-text-spacing-comfortable">
                {{ "a11y.preferences.textSpacing.comfortable" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="spacious" data-testid="a11y-pref-text-spacing-spacious">
                {{ "a11y.preferences.textSpacing.spacious" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <!-- Line height (vertical spacing between lines) -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">format_line_spacing</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-line-height-label">
                    {{ "a11y.preferences.lineHeight.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.lineHeight.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().lineHeight"
            (change)="setLineHeight($event.value)"
            aria-labelledby="a11y-pref-line-height-label"
            data-testid="a11y-pref-line-height">
            <mat-button-toggle value="normal" data-testid="a11y-pref-line-height-normal">
                {{ "a11y.preferences.lineHeight.normal" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="comfortable" data-testid="a11y-pref-line-height-comfortable">
                {{ "a11y.preferences.lineHeight.comfortable" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="spacious" data-testid="a11y-pref-line-height-spacious">
                {{ "a11y.preferences.lineHeight.spacious" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <h4 class="cipo-text--bold-lg p-y-sm" id="a11y-section-color-vision">
        {{ "a11y.preferences.sections.colorVision" | translate }}
    </h4>

    <!-- Contrast -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">contrast</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-contrast-label">
                    {{ "a11y.preferences.contrast.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.contrast.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().contrast"
            (change)="setContrast($event.value)"
            aria-labelledby="a11y-pref-contrast-label"
            data-testid="a11y-pref-contrast">
            <mat-button-toggle value="normal" data-testid="a11y-pref-contrast-normal">
                {{ "a11y.preferences.contrast.normal" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="high" data-testid="a11y-pref-contrast-high">
                {{ "a11y.preferences.contrast.high" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="invert" data-testid="a11y-pref-contrast-invert">
                {{ "a11y.preferences.contrast.invert" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <!-- Saturation -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">palette</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-saturation-label">
                    {{ "a11y.preferences.saturation.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.saturation.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().saturation"
            (change)="setSaturation($event.value)"
            aria-labelledby="a11y-pref-saturation-label"
            data-testid="a11y-pref-saturation">
            <mat-button-toggle value="normal" data-testid="a11y-pref-saturation-normal">
                {{ "a11y.preferences.saturation.normal" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="low" data-testid="a11y-pref-saturation-low">
                {{ "a11y.preferences.saturation.low" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="high" data-testid="a11y-pref-saturation-high">
                {{ "a11y.preferences.saturation.high" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="desaturate" data-testid="a11y-pref-saturation-desaturate">
                {{ "a11y.preferences.saturation.desaturate" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <!-- Colour-blind correction -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">colorize</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-color-filter-label">
                    {{ "a11y.preferences.colorFilter.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.colorFilter.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            vertical
            [value]="userStore.a11y().colorFilter"
            (change)="setColorFilter($event.value)"
            aria-labelledby="a11y-pref-color-filter-label"
            data-testid="a11y-pref-color-filter">
            <mat-button-toggle value="normal" data-testid="a11y-pref-color-filter-normal">
                {{ "a11y.preferences.colorFilter.normal" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="protanopia" data-testid="a11y-pref-color-filter-protanopia">
                {{ "a11y.preferences.colorFilter.protanopia" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="deuteranopia" data-testid="a11y-pref-color-filter-deuteranopia">
                {{ "a11y.preferences.colorFilter.deuteranopia" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="tritanopia" data-testid="a11y-pref-color-filter-tritanopia">
                {{ "a11y.preferences.colorFilter.tritanopia" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <h4 class="cipo-text--bold-lg p-y-sm" id="a11y-section-motion-aids">
        {{ "a11y.preferences.sections.motionAids" | translate }}
    </h4>

    <!-- Reduce motion -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">animation</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-motion-label">
                    {{ "a11y.preferences.reduceMotion.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.reduceMotion.hint" | translate }}</span>
            </div>
        </div>
        <mat-slide-toggle
            [checked]="userStore.a11y().reduceMotion"
            (change)="setReduceMotion($event)"
            aria-labelledby="a11y-pref-motion-label"
            data-testid="a11y-pref-reduce-motion"></mat-slide-toggle>
    </div>

    <mat-divider />
    <!-- Reading aid -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">chrome_reader_mode</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-reading-aid-label">
                    {{ "a11y.preferences.readingAid.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.readingAid.hint" | translate }}</span>
            </div>
        </div>
        <mat-button-toggle-group
            [value]="userStore.a11y().readingAid"
            (change)="setReadingAid($event.value)"
            aria-labelledby="a11y-pref-reading-aid-label"
            data-testid="a11y-pref-reading-aid">
            <mat-button-toggle value="off" data-testid="a11y-pref-reading-aid-off">
                {{ "a11y.preferences.readingAid.off" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="guide" data-testid="a11y-pref-reading-aid-guide">
                {{ "a11y.preferences.readingAid.guide" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="mask" data-testid="a11y-pref-reading-aid-mask">
                {{ "a11y.preferences.readingAid.mask" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-divider />

    <!-- Large cursor -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">mouse</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-large-cursor-label">
                    {{ "a11y.preferences.largeCursor.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.largeCursor.hint" | translate }}</span>
            </div>
        </div>
        <mat-slide-toggle
            [checked]="userStore.a11y().largeCursor"
            (change)="setLargeCursor($event)"
            aria-labelledby="a11y-pref-large-cursor-label"
            data-testid="a11y-pref-large-cursor"></mat-slide-toggle>
    </div>

    <mat-divider />

    <!-- Underline links -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="p-y-sm">
        <div fxFlex fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start start">
            <mat-icon aria-hidden="true">link</mat-icon>
            <div fxLayout="column">
                <span class="cipo-text--medium-md" id="a11y-pref-underline-links-label">
                    {{ "a11y.preferences.underlineLinks.title" | translate }}
                </span>
                <span class="cipo-material--hint">{{ "a11y.preferences.underlineLinks.hint" | translate }}</span>
            </div>
        </div>
        <mat-slide-toggle
            [checked]="userStore.a11y().underlineLinks"
            (change)="setUnderlineLinks($event)"
            aria-labelledby="a11y-pref-underline-links-label"
            data-testid="a11y-pref-underline-links"></mat-slide-toggle>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (hasCustomSettings()) {
        <button mat-button (click)="resetToDefaults()" data-testid="a11y-pref-reset">
            {{ "a11y.preferences.reset" | translate }}
        </button>
    }
</mat-dialog-actions>
